<template>
  <material-card
    :title="renderTitle"
    :text="subtitle"
    color="primary">
    <template slot='headerActions'>
      <slot name='headerActions'/>
    </template>
    <v-form
      class="mt-4"
      ref="form"
      lazy-validation
      v-model="validForm"
      autocomplete="off"
      role="presentation">
      <v-container grid-list-md>
        <slot name="prebody"></slot>
        <v-layout wrap>
          <core-field
            v-for="field in fields"
            :readonly="(typeof field.readonly === 'function' ? field.readonly(item, $store.state) : field.readonly) || (!isForceEditable(field) && readonly)"
            :key="field.value"
            :field="field"
            :item="item"
            v-model="item[field.value]" />
        </v-layout>
      </v-container>
    </v-form>

    <v-flex
      xs12
      text-right>
      <v-btn
        v-if="modal"
        id="close_btn"
        class="mx-1 font-weight-light"
        color="success"
        @click="close()"
      >Close</v-btn>

      <v-btn
        v-if="($can('update', entityName) || $can('upsert', entityName)) && (!readonly || hasForceEditableFields) && !hideSave"
        :id="`${modal ? 'modal_' : ''}${isNew ? 'save_btn' : 'update_btn'}`"
        :disabled="!checkSave() && !validForm || loading"
        class="mx-1 white--text"
        color="purple"
        :loading='loading'
        @click="save()"> {{ isNew ? 'Save' : 'Update' }} </v-btn>

      <slot name="actions" :item='item' :valid='validForm' />

    </v-flex>
  </material-card>
</template>

<script>

import validators from '@/utils/validators'
import { upperFirst as uf } from 'lodash'

const { upsert, getDetail } = require('@/api/base_entity')

export default {
  props: {
    config: { type: Object, default () {} },
    modal: { type: Boolean, default: false },
    subtitle: { type: String, default: '' },
    title: { type: [String, Boolean], default: '' },
    readonly: { type: [Boolean, Number], default: false },
    hideSave: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    apiUpsert: { type: Function, default: upsert },
    apiGetdetail: { type: Function, default: getDetail },
  },
  data () {
    return {
      loading: false,
      validForm: false,
      validators,
      entityName: this.config.entityName,
      fields: this.config.fields,
      isNew: false
    }
  },
  destroyed () {
    this.$root.$off('itemUpdated')
  },
  mounted () {
    const form = this.$refs.form
    this.$root.$on('itemUpdated', form.validate)
    this.$nextTick( () => {
      this.isNew = !this.entityId
    })
  },
  computed: {
    entityId () {
      if (!this.config?.id) {
        return this.item['id']
      }

      if (typeof this.config.id === 'string') {
        return this.item[this.config.id]
      }

      if (Array.isArray(this.config.id) && this.config.id.length>0) {
        const entityId = []
        for (const key of this.config.id) {
          if (!this.item[key]) return false
          entityId.push(this.item[key])
        }
        return entityId.join('_')
      }

      console.error('Wrong entity id format? ', this.config.id)
      return false
    },
    renderTitle () {
      if (this.config.title === false || this.title === false) return ''
      if (this.title) return this.title
      const title = this.config.title || uf(this.entityName)
      return this.isNew ? 'New ' + title : ((this.readonly && !this.hasForceEditableFields) ? title + ' Details' : 'Edit ' + title)
    },
    hasForceEditableFields () {
      return this.fields.some(field => this.isForceEditable(field))
    },
  },
  watch: {
    validForm (value) {
      this.$emit('update:valid', value)
    }
  },
  methods: {
    isForceEditable (field) {
      return typeof field.forceEditable === 'function' ? field.forceEditable(this.item, this.$store.state) : !!field.forceEditable
    },
    validate () {
      return this.$refs.form.validate()
    },
    checkSave () {
      return !this.isNew
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      this.apiUpsert(this.entityName, this.item, !this.isNew && this.entityId)
        .then(data => {
          this.$emit('saved', { data: data.data || data, item: this.item })
          this.$root.$emit('openSnackbar', {
            message: (this.title || this.config.title || uf(this.entityName)) + ' updated correctly',
            color: 'success'
          })
          this.close()
        })
        .catch(e => {
          const msg = (e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0]) ||
            e?.response?.data?.error || e?.response?.data?.message
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the ' + uf(this.entityName) + ' update. ' +
              (msg || 'Error'),
            color: 'error'
          })
        })
        .finally (() => {
          this.loading = false
        })
    }
  }
}
</script>
